import { CustomTableData } from 'common'
import { TooltipInformation } from 'common'
import { MenuOptions } from './Dropdown'

export const CollateralTable = ({ useFetchInit }) => {

    const { FetchData, Actions } = useFetchInit
    const { fetchAllCollateral: { collateral } } = FetchData

    const columnConfig = [
        {
            headerName: "Info",
            maxWidth: 80,
            cellStyle: () => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }),
            cellRenderer: (params) => {
                const { idvehicledeposit, usuario_creo, fecha_creo, usuario_modifico, fecha_modifico } = params.data
                return (
                    <TooltipInformation
                        idregistro={idvehicledeposit}
                        usuario_creo={usuario_creo}
                        fecha_creo={fecha_creo}
                        usuario_modifico={usuario_modifico}
                        fecha_modifico={fecha_modifico}
                    />
                )
            }
        },
        {
            field: "idcredito",
            headerName: "CREDITO",
            maxWidth: 120,
            minWidth: 120,
            filter: true,
            cellRenderer: (params) => `CRED${params.value}`,
        },
        { field: "type_collateral", headerName: "TIPO DE GARANTIA", minWidth: 300, filter: true },
        { field: "title", headerName: "TITLE", minWidth: 500, filter: true },
        { field: "valor", headerName: "VALOR (Q)", minWidth: 200, filter: true },

        // ✅ OPCIONES (Dropdown)
        {
            headerName: "OPCIONES",
            minWidth: 420,
            cellRenderer: (params) => (
                <MenuOptions params={params} Actions={Actions} />
            )
        },
    ]

    return (
        <div className='content'>
            <CustomTableData
                rowConfig={collateral}
                columnConfig={columnConfig}
            />
        </div>
    )
}